import { Button, Flex, IconDownloadLine } from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import DownloadModal from "./DownloadModal";

const CurrentMapNav = ({ rows, cols, futureMap, badgeMappings }) => {
  const [open, setOpen] = useState(false);

  return (
    <Flex margin="0 0 small 0" gap="small" direction="row-reverse">
      <Flex.Item>
        <Button
          size="small"
          color="primary"
          renderIcon={IconDownloadLine}
          onClick={() => setOpen(true)}
          disabled={rows.length === 0}
        >
          {t("manageMap.download")}
        </Button>
      </Flex.Item>
      <DownloadModal
        open={open}
        setOpen={setOpen}
        rows={rows}
        cols={cols}
        futureMap={futureMap}
        badgeMappings={badgeMappings}
      />
    </Flex>
  );
};

export default CurrentMapNav;
